import { useMemo } from 'react';
import { Eye2LineIcon, RoundElement, StarLineIcon } from 'ui';

type P = {
  channelAppearance: { featured?: boolean; visible?: boolean };
};

export const useGetChannelAppearanceInformation = ({ channelAppearance }: P) =>
  useMemo(() => {
    if (channelAppearance.featured) {
      return {
        description: 'Object will be visible as featured in Channels',
        icon: (
          <RoundElement color="default" size="extra-small">
            <StarLineIcon type="dark-default" />
          </RoundElement>
        ),
        name: 'Featured',
      };
    }

    if (channelAppearance.visible) {
      return {
        description: 'Object will be visible in Channels',
        icon: (
          <RoundElement color="default" size="extra-small">
            <Eye2LineIcon type="dark-default" />
          </RoundElement>
        ),
        name: 'Visible',
      };
    }

    return undefined;
  }, [channelAppearance]);
